import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IAlertService } from './alert-service';
import { AlertSnackbar } from './alert-snackbar/alert-snackbar';
import { AlertConfig } from './alert.config';

@Injectable()
export class AlertService implements IAlertService {
    private readonly snackBar: MatSnackBar = inject(MatSnackBar);

    success(message: string, config: AlertConfig = {}): void {
        this.snackBar.openFromComponent(AlertSnackbar, {
            data: { message },
            panelClass: 'snackbar-success',
            duration: config.duration ?? 3000,
        });
    }

    error(message: string, config: AlertConfig = {}): void {
        this.snackBar.openFromComponent(AlertSnackbar, {
            data: { message },
            panelClass: 'snackbar-error',
            duration: config.duration,
        });
    }

    info(): void {
        throw new Error('Method not implemented.');
    }

    warning(message: string, config: AlertConfig = {}): void {
        this.snackBar.openFromComponent(AlertSnackbar, {
            data: { message },
            panelClass: 'snackbar-warning',
            duration: config.duration,
        });
    }
}
